export const Trending = () => {
    return (
        <>
            <div className="c-trending">
                <div className="c-trending-content">
                    <h1>THE HOLIDAYS ARE ALMOST HERE.</h1>
                    <h3>DON’T STRESS. CHECK OUR LATEST PRODUCTS.</h3>
                    <button className="c-trending-btn">CHECK NOW!</button>
                </div>
            </div>
        </>
    )
}